<div class="main-content">
  <div class="add-photo-header">
    <h1>{{ "induction_completed_add_photo_title" | translate }}</h1>
  </div>
  <div class="color-dark-blue">
    <p>{{ "induction_completed_add_photo_details" | translate }}</p>
  </div>
  <div>
    <form [formGroup]="addPhotoFormGroup" class="add-photo-form">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label class="color-city-blue">{{
          "induction_completed_add_photo_reason" | translate
        }}</mat-label>
        <mat-select
          id="visitor_type_upload_reason"
          name="visitor_type_upload_reason"
          formControlName="uploadReasonSelection"
        >
          @for (reason of visitorTypeUploadReasons; track reason) {
          <mat-option [value]="reason.id">
            {{ reason.displayDescription }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">{{
          "induction_completed_add_photo_comments" | translate
        }}</mat-label>
        <textarea
          matInput
          data-testid="induction_completed_add_photo_comments"
          formControlName="comments"
          cdkTextareaAutosize
          cdkAutosizeMinRows="5"
        ></textarea>
        @if (hasError(addPhotoFormGroup, 'comments')) {
        <mat-error>{{ getError(addPhotoFormGroup, "comments") }}</mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <div class="divider"></div>
  <button
    mat-raised-button
    id="induction_completed_add_photo_camera"
    data-testid="induction_completed_add_photo_camera"
    [disabled]="disableCameraButton()"
    (click)="capturePhoto()"
    [disabled]="!addPhotoFormGroup.get('uploadReasonSelection')?.value"
  >
    <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
      <mat-icon class="add-photo-icon">camera_alt</mat-icon>
      {{ "induction_completed_add_photo_camera" | translate }}
    </div>
  </button>
  <div class="divider"></div>
  <button
    mat-stroked-button
    class="color-city-blue btn-border-color"
    id="induction_completed_add_photo_cancel"
    data-testid="induction_completed_add_photo_cancel"
    (click)="closeAddPhoto()"
  >
    {{ "induction_completed_add_photo_cancel" | translate }}
  </button>
</div>
